import { render, staticRenderFns } from "./sop.vue?vue&type=template&id=136fe333&"
import script from "./sop.vue?vue&type=script&lang=js&"
export * from "./sop.vue?vue&type=script&lang=js&"
import style0 from "./sop.vue?vue&type=style&index=0&id=136fe333&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports